var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/dashboard",
        pageTitle: _vm.title,
        backLink: "/dashboard/reports",
      },
    },
    [
      _vm.can("View admin reports")
        ? _c(
            "v-list-item-subtitle",
            {
              staticClass: "font-bold pa-4 pt-0",
              staticStyle: { "white-space": "normal" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "soli-round soli-blue-text",
                  attrs: {
                    "x-small": "",
                    outlined: "",
                    href: `/dashboard/reports/${
                      _vm.attribute
                    }-performance?allLocations=${_vm.allLocations ? 0 : 1}`,
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.allLocations
                        ? `View ${_vm.$page.props.auth.user.selected_location.name}`
                        : `View All Locations`
                    )
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        _vm._l(_vm.items, function (item) {
          return _c(
            "v-col",
            { key: item.id, attrs: { cols: "12", lg: "6", xl: "4" } },
            [
              _c(
                "v-card",
                { staticClass: "soli-round" },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pb-0 soli-grey",
                          staticStyle: {
                            "max-height": "64px",
                            position: "relative",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.title) +
                              " "
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  item.showStatsHelp = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("help"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs",
                        {
                          staticClass: "custom-tabs px-4",
                          model: {
                            value: item.tab,
                            callback: function ($$v) {
                              _vm.$set(item, "tab", $$v)
                            },
                            expression: "item.tab",
                          },
                        },
                        _vm._l(_vm.stats, function (stat) {
                          return _c(
                            "v-tab",
                            {
                              key: stat.title,
                              attrs: { disabled: stat.disabled },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(stat.title) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          attrs: { touchless: "" },
                          model: {
                            value: item.tab,
                            callback: function ($$v) {
                              _vm.$set(item, "tab", $$v)
                            },
                            expression: "item.tab",
                          },
                        },
                        _vm._l(_vm.stats, function (stat, idx) {
                          return _c(
                            "v-tab-item",
                            {
                              key: stat.title,
                              class: {
                                "stat-with-options": stat.hasOptions,
                              },
                              staticStyle: { "min-height": "304px" },
                              attrs: { transition: false },
                            },
                            [
                              idx == item.tab
                                ? _c("AttributeStat", {
                                    staticClass:
                                      "animate__animated animate__fadeIn",
                                    attrs: {
                                      attribute: _vm.attribute,
                                      value: item,
                                      showStatsHelp: item.showStatsHelp,
                                      metric: stat.slug,
                                      table: stat.table,
                                      defaultOption: stat.defaultOption,
                                      help: stat.help,
                                      allLocations: _vm.allLocations,
                                    },
                                    on: {
                                      selectOption: function ($event) {},
                                      rendered: _vm.redrawVueMasonry,
                                      reset: function ($event) {
                                        _vm.closeModal(
                                          () => (item.showStatsHelp = false)
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }